import { useQuery } from "@tanstack/react-query"
import type { LastAIResponseResponse } from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

/**
 * One-shot fetch of the most recent AI response for a property. Realtime
 * updates after first render flow through `usePropertyChannel`, which writes
 * directly into the query cache via `queryClient.setQueryData` rather than
 * triggering a refetch.
 */
export function useLastAIResponse(propertyId: string | undefined) {
	return useQuery({
		queryKey: propertyId
			? queryKeys.lastAiResponse(propertyId)
			: ["properties", "__nil__", "ai-response-last"],
		queryFn: () =>
			apiFetch<LastAIResponseResponse>(
				`/api/common/properties/${encodeURIComponent(propertyId as string)}/ai-responses/last`,
			).then((res) => res.lastAiResponse),
		enabled: !!propertyId,
	})
}
